import { get } from "lodash"
import createModule from "../createModule"
import view from "./view"
import { Creators } from "./model"
import { getNotifications, getAverageCompletion } from "./selectors"

export default createModule({
  view,
  externalProps: state => ({
    account: state.global.selected.account,
  }),
  required: ["account"],
  data: [{
    resource: "notifications",
    as: null,
    url: ({ account }) => `/api/${account}/notifications`,
  }, {
    resource: "portfolios",
    as: null,
    url: ({ account }) => `/api/${account}/portfolios`,
  }, {
    resource: "experiments",
    as: null,
    url: ({ account }) => `/api/${account}/experiments`,
  }, {
    resource: "watchlists",
    as: null,
    url: () => ({
      id: "watchlists",
      query: "query { watchlists { id, name, alias } }",
    }),
  }],
  mapStateToProps: (state) => ({
    open: get(state, "modules.serverNotifications.open"),
    notifications: getNotifications(state),
    averageCompletion: getAverageCompletion(state),
  }),
  actions: {
    ...Creators,
  },
})
